import { Injectable } from '@angular/core';
import * as angular from 'angular';
import { IUndoService } from './IUndoService';

/**
 * Encapsulates common logic for undoing edits to a form.
 * If making edits, take care to not introduce memory leaks by holding onto references.
 */
@Injectable({
    providedIn: 'root'
})
export class UndoService implements IUndoService {
    public static $name: string = 'undoService';

    public undo(form: angular.IFormController, currentState: any, initialState: any) {
        form.$setPristine();
        form.$setUntouched();

        angular.merge(currentState, initialState);
    }
}
